import React, { useState, useEffect, useMemo } from 'react';
import ResourceTable from './components/ResourceTable';
import AllPlansTable from './components/AllPlansTable';

const App = () => {
  const [resources, setResources] = useState([]);
  const [plans, setPlans] = useState([]);
  const [selectedNodes, setSelectedNodes] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchResourcesAndPlans = async () => {
      try {
        const [resourcesRes, plansRes] = await Promise.all([
          fetch('https://netwayprime.com/wp-json/jet-cct/cml_resource'),
          fetch('https://netwayprime.com/wp-json/jet-cct/cml_service_plans')
        ]);
        
        const resourcesData = await resourcesRes.json();
        const plansData = await plansRes.json();
        
        setResources(resourcesData);
        setPlans(plansData.sort((a, b) => parseFloat(a.vcpu) - parseFloat(b.vcpu)));
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };
    
    fetchResourcesAndPlans();
  }, []);

  const totalResources = useMemo(() => {
    let newTotalVcpu = 0;
    let newTotalMemory = 0;

    for (const key in selectedNodes) {
      const node = selectedNodes[key];
      newTotalVcpu += node.vcpu * node.count;
      newTotalMemory += node.memory * node.count;
    }
    return { totalVcpu: newTotalVcpu, totalMemory: newTotalMemory };
  }, [selectedNodes]);
  
  const hasSelectedItems = Object.keys(selectedNodes).length > 0;

  return (
    <div className="cml-calculator-container">
      {loading ? (
        <div>در حال بارگذاری...</div>
      ) : (
        <>
          <ResourceTable 
            resources={resources} 
            selectedNodes={selectedNodes} 
            setSelectedNodes={setSelectedNodes} 
          />
          
          {hasSelectedItems && (
            <div className="totals">
              <h3>مجموع منابع مورد نیاز شما:</h3>
              <p>vCPUs: <span>{totalResources.totalVcpu.toFixed(2)}</span></p>
              <p>Memory: <span>{totalResources.totalMemory.toFixed(2)} GB</span></p>
            </div>
          )}
          
          <AllPlansTable 
            plans={plans} 
            totalVcpu={totalResources.totalVcpu}
            totalMemory={totalResources.totalMemory}
          />
        </>
      )}
    </div>
  );
};

export default App;